import { Box, Modal, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material'
import React from 'react'
interface SearchModalProps {
    open: boolean;
    handleClose: () => void;
    data:any;
    setTests: (code:string|null)=> void;
  }

  const TestNameModal: React.FC<SearchModalProps> = ({ open, handleClose,data,setTests}) => {
  return (
    <Modal open={open} onClose={handleClose} >
    <Box sx={{ 
      position: 'absolute', 
      top: '50%', 
      left: '50%', 
      transform: 'translate(-50%, -50%)', 
      backgroundColor: 'white', 
      padding: '20px', 
      borderRadius: open ? '10px' : '0',  
      border: 'none',
      maxHeight: '300px', 
      
      '&:focus': { border: 'none', outline: 'none' },
      /* Style scrollbar */
      
    }}>
      <Box display={'flex'} justifyContent={'center'} alignItems={'center'} flexDirection={'column'}>
        <Typography sx={{fontWeight:'bold'}}>Searched list</Typography>
        
      </Box>
      <Box sx={{ overflowY: 'auto', maxHeight: 'calc(200px)','&::-webkit-scrollbar': {
        width: '6px',
      },
      '&::-webkit-scrollbar-thumb': {
        backgroundColor: '#888',
        borderRadius: '6px',
      }, }}>
        <TableContainer component={Paper} style={{ border: 'none' }}>
          <Table sx={{ textAlign: 'center' }}>
            <TableHead>
              <TableRow>
              <TableCell>#</TableCell>
                <TableCell>Test Code</TableCell>
                <TableCell>Test Name</TableCell>
                
              </TableRow>
            </TableHead>
            <TableBody>
              {data?.map((row:any, index:any) => (
                <TableRow key={index} sx={{ '&:hover': { backgroundColor: '#f0f0f0', cursor: 'pointer' } }} onClick={()=>setTests(row?.testCode)}>
                    <TableCell>{index+1}</TableCell>
                  <TableCell>{row?.testCode}</TableCell>
                  <TableCell>{row?.testName}</TableCell>
                
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
    </Box>
  </Modal>
  )
}

export default TestNameModal